import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AppProvider } from './context/AppContext'
import { LanguageProvider } from './context/LanguageContext'
import AdminDashboard from './components/AdminDashboard'
import GuestPage from './pages/GuestPage'
import AdminLogin from './components/AdminLogin'
import AdminWelcome from './components/AdminWelcome'
import AdminCode from './components/AdminCode'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import GiftsPage from './pages/GiftsPage'

import './styles/Global.css'
import EditSettings from './components/AdminEditSettings'
import { useState } from 'react'

function App() {
  const [wifeName, setWifeName] = useState('')
  const [husbandName, setHusbandName] = useState('')
  return (
    <>
      <LanguageProvider>
        <AppProvider>
          <Router>
            <Navbar husbandFirstName={husbandName} wifeFirstName={wifeName} />

            <Routes>
              <Route path="/" element={<AdminWelcome />} />
              <Route path="/welcome" element={<AdminWelcome />} />
              <Route path="/code" element={<AdminCode />} />
              <Route path="/settings" element={<EditSettings />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/gifts" element={<GiftsPage />} />
              <Route
                path="/rsvp/:id"
                element={
                  <GuestPage
                    husbandFirstName={husbandName}
                    wifeFirstName={wifeName}
                    setHusbandFirstName={setHusbandName}
                    setWifeFirstName={setWifeName}
                  />
                }
              />
              <Route path="/admin-login" element={<AdminLogin />} />
            </Routes>
            <Footer />
          </Router>
        </AppProvider>
      </LanguageProvider>
    </>
  )
}

export default App
